export class ApplyInviteParams {
  invite: string

  constructor({ invite }: { invite: string }) {
    this.invite = invite
  }
}
